import { action, makeObservable, observable } from 'mobx';
import { CountryCode } from 'core/config/country-code';
import { FeatureFlag } from 'core/enums/feature-flag';
import { PermissionType } from 'core/enums/permission-type';
import { FeatureStore } from 'core/stores/feature.store';

export class DevToolsStore {
  isOpen = true;
  accNum!: number;
  payPlatform: string = localStorage.getItem('ci.payment-platform-override') || '';
  featureMap!: Map<string, PermissionType>;
  countries = CountryCode;

  constructor(private countryCode: string) {
    makeObservable(this, {
      isOpen: observable,
      accNum: observable,
      payPlatform: observable,
      countries: observable,
      changeIsOpen: action,
      changeAccNum: action,
      changePayMethod: action,
      changeCountries: action,
    });

  }

  initialize(featureMap: Map<string, PermissionType>, accNum: string) {
    this.accNum = +accNum;
    this.featureMap = featureMap;
  }

  changeIsOpen(isOpen: boolean) {
    this.isOpen = isOpen;
  }

  changeAccNum(accNum: number) {
    this.accNum = accNum;
  }

  changePayMethod(payPlatform: string) {
    this.payPlatform = payPlatform;
  }

  changeCountries(countries: { alpha2: string; alpha3: string; full: string; }[]) {
    this.countries = countries;
  }

  hasFeature(feature: FeatureFlag) {
    return FeatureStore.hasViewPermission(this.featureMap, feature)
  }
}